module.exports = __webpack_public_path__ + "img/noProfile.4c5b43de.png";